import React ,{ Component }from "react";
import { FiCast , FiLayers , FiUsers , FiMonitor } from "react-icons/fi";

const ServiceList = [
    {
        icon: <FiCast />,
        title: 'Digital Strategy',
        description: 'Align your digital presence with your business goals through purposeful planning, clear priorities, and a roadmap for sustainable growth.'
    },
    {
        icon: <FiLayers />,
        title: 'UI/UX Design',
        description: 'Design intuitive digital experiences with thoughtful layouts, seamless navigation, and user-focused interfaces that make every interaction effortless.'
    },
    {
        icon: <FiMonitor />,
        title: 'Custom Web Development',
        description: 'Build high-performance websites tailored to your needs, combining clean code, responsive design, and scalable architecture.'
    },
    {
        icon: <FiUsers />,
        title: 'Web Applications',
        description: 'Transform complex business processes into intuitive digital tools that streamline workflows and deliver better customer experiences.'
    },
    {
        icon: <FiLayers />,
        title: 'E-commerce Development',
        description: 'Create seamless online stores with intuitive product discovery, secure checkout, and a shopping experience designed to drive sales.'
    },
    {
        icon: <FiMonitor />,
        title: 'Website Optimisation',
        description: 'Improve speed, accessibility, search visibility, and usability to help your website perform better and convert more visitors.'
    }
];


class ServiceThree extends Component{
    render(){
        const {column } = this.props;
        const ServiceContent = ServiceList.slice(0 , this.props.item);
        
        return(
            <React.Fragment>
                <div className="row">
                    {ServiceContent.map( (val , i) => (
                        <div className={`${column}`} key={i}>
                                <div className="service service__style--2">
                                    <div className="icon">
                                        {val.icon}
                                    </div>
                                    <div className="content">
                                        <h3 className="title">{val.title}</h3>
                                        <p>{val.description}</p>
                                    </div>
                                </div>
                        </div>
                    ))}
                </div>
            </React.Fragment>
        )
    }
}
export default ServiceThree;
